import { HashMap } from '@jsverse/transloco';
import { TranslationService } from '@lib/i18n/data-access';
import { ToastService } from '@platform-workspace/design-system-v2';
import { UploadWidgetItemSection, UploadWidgetItemStatus } from '@shared/utils/enums';
import { UploadWidgetItemDto } from '@shared/utils/interfaces';

import { TOAST_VARIANT_I18N_KEY, ToastVariant } from './upload-widget.constant';
import { UploadWidgetState } from './upload-widget.interface';

/** Shows the section-specific toast for an upload outcome. */
export const showSectionToast = (
  toastService: ToastService,
  translationService: TranslationService,
  section: UploadWidgetItemSection,
  variant: ToastVariant,
  params?: HashMap,
): void => {
  const message = translationService.translate(`uploadWidget.toast.${section}.${TOAST_VARIANT_I18N_KEY[variant]}`, params);

  if (variant === 'error' || variant === 'failed') {
    toastService.showError(message);
  } else if (variant === 'warning') {
    toastService.showInfo(message);
  } else {
    toastService.showSuccess(message);
  }
};

/** Returns a state patch updating the status of a single record by uuid. */
export const setRecordStatus = (
  store: { registeredUploads: () => UploadWidgetItemDto[] },
  uuid: string,
  status: UploadWidgetItemStatus,
): Partial<UploadWidgetState> => {
  return {
    registeredUploads: store.registeredUploads().map((record) => (record.uuid === uuid ? { ...record, status } : record)),
  };
};
